<app-header></app-header>
<ion-content>
  <div class="scrolling-element" cdkVirtualScrollingElement>
    <div class="search-layout">
      <section *ngIf="isTopSection">
        <ng-container *ngTemplateOutlet="topSection"></ng-container>
      </section>
      <app-new-search-facet-skeleton
        *ngIf="!!newSearchViewModel?.facetLoadingState && newSearchViewModel?.facetLoadingState === SearchLoadingState.loading"
      ></app-new-search-facet-skeleton>
      <ng-container
        *ngIf="isTouchExperience && (!!newSearchViewModel?.facetLoadingState &&
          newSearchViewModel?.facetLoadingState !== SearchLoadingState.loading &&
          newSearchViewModel?.facetLoadingState !== SearchLoadingState.error)"
        [ngTemplateOutlet]="SearchResultsHeader"
      ></ng-container>
      <div
        class="search-content"
        [ngClass]="{'desktop': isTouchExperience === false}"
      >
        <div class="search-results">
          <ng-container
            *ngIf="!isTouchExperience && (!!newSearchViewModel?.facetLoadingState &&
              newSearchViewModel?.facetLoadingState !== SearchLoadingState.loading )"
            [ngTemplateOutlet]="SearchResultsHeader"
          ></ng-container>

          <app-new-search-skeleton
            *ngIf="!!newSearchViewModel?.loadingState && newSearchViewModel?.loadingState === SearchLoadingState.loading && !isLoadingNextBatch"
          ></app-new-search-skeleton>
          <app-new-search-result
            *ngIf="!!newSearchViewModel?.loadingState &&
              newSearchViewModel?.loadingState !== SearchLoadingState.loading &&
              newSearchViewModel?.loadingState !== SearchLoadingState.error &&
              newSearchViewModel?.totalCount !== 0 || isLoadingNextBatch"
            [pwrRatingStarsMap]="pwrRatingStarsMap | async"
            [newSearchViewModel]="newSearchViewModel"
            (selectionChange)="handleSelectedProducts($event)"
            [isTouchExperience]="isTouchExperience"
            [itemsSelectable]="!!selection"
            [itemHeights]="itemHeights"
            (scrolledIndexChange)="nextBatch($event)"
            [topSellers]="newTopSellers$ | async"
            [addMethod]="this.route?.snapshot?.params['listingName']"
          ></app-new-search-result>
          <div
            *ngIf="newSearchViewModel?.loadingState === SearchLoadingState.loadingNextPage"
            class="new-search-result-skeleton-wrapper"
          >
            <ion-skeleton-text animated="true" class="item"></ion-skeleton-text>
            <ion-skeleton-text animated="true" class="item"></ion-skeleton-text>
            <ion-skeleton-text animated="true" class="item"></ion-skeleton-text>
            <ion-skeleton-text animated="true" class="item"></ion-skeleton-text>
          </div>
        </div>
      </div>
      <ng-container
        *ngIf="((newSearchViewModel?.loadingState === SearchLoadingState.loaded && newSearchViewModel?.products?.length === 0)|| newSearchViewModel?.loadingState === SearchLoadingState.error)"
      >
        <app-search-result-not-found
          [search]="newSearchViewModel?.searchText"
          [isNewSearch]="true"
          [searchLoadingState]="newSearchViewModel?.loadingState"
          [coveoTopSellers]="newTopSellers$ | async"
          [hasFacetsSelected]="hasFacetsApplied"
          (handleReloadResults)="reloadResults()"
          (clearAllFacets)="clearAllFacets()"
        >
        </app-search-result-not-found>
      </ng-container>
    </div>
    <app-footer></app-footer>
  </div>
  <div class="sticky-action-bar-container">
    <app-search-top-button
      class="top-button"
      [isMobile]="this.platformService.platformType === platformService.platformEnum.mobile"
      [class.selected-products]="selectedProducts?.length > 0"
      [class.mobile]="this.platformService.platformType === platformService.platformEnum.mobile"
      [class.tablet]="this.platformService.platformType === platformService.platformEnum.tablet"
      (scrollToTop)="scrollToTop()"
    ></app-search-top-button>
    <app-mobile-search-operations
      *ngIf="(!!newSearchViewModel?.facetLoadingState &&
      newSearchViewModel?.facetLoadingState !== SearchLoadingState.loading &&
      newSearchViewModel?.facetLoadingState !== SearchLoadingState.error) &&
      platformService?.platformType === platformService?.platformEnum?.mobile &&
      (newSearchViewModel?.totalCount > 0 || hasFacetsApplied)"
      [selection]="selection"
      [isGuestUser]="isGuestUser"
      [showInventory]="showInventory && !isAddToList"
      [isAddToList]="isAddToList"
      [isInventory]="isInventory"
      [isThreeOperationButtons]="isThreeOperationButtons"
      (selectionChange)="handleSelectionTypeChange($event)"
      class="sticky-operations"
    ></app-mobile-search-operations>
    <!-- <ng-container *ngTemplateOutlet="SearchOperationsMobile;"></ng-container> -->
    <app-sticky-action-bar
      *ngIf="
          selectedProducts?.length > 0 &&
          selection === SelectionType.CompareProducts
        "
      [selectionCount]="selectedProducts?.length"
      [selectionCountText]="'Compare ' + selectedProducts?.length + ' of 4'"
      [primaryButtonText]="'i18n.search.compare' | translate"
      [isPrimaryButtonDisabled]="selectedProducts?.length < 2"
      dataCy="compare-products"
      (clearSelection)="clearSelectedProducts()"
      (primaryAction)="redirectToComparePage()"
    ></app-sticky-action-bar>
    <app-sticky-action-bar
      *ngIf="
          selectedProducts?.length > 0 &&
          selection === SelectionType.AddToList
        "
      [selectionCountText]="selectedProductText"
      [selectionCount]="selectedProducts?.length"
      [primaryButtonText]="'i18n.search.addToList' | translate"
      dataCy="add-to-list"
      (clearSelection)="clearSelectedProducts()"
      (primaryAction)="openActionModal()"
    ></app-sticky-action-bar>
    <app-sticky-action-bar
      *ngIf="selectedProducts?.length > 0 &&
      selection === SelectionType.AddToInventory"
      [selectionCount]="selectedProducts?.length"
      [selectionCountText]="selectedProductText"
      [primaryButtonText]="'i18n.search.addToInventory' | translate"
      dataCy="add-to-inventory"
      (clearSelection)="clearSelectedProducts()"
      (primaryAction)="openAddToInventoryModal()"
    ></app-sticky-action-bar>
  </div>
  <ion-modal
    [isOpen]="this.addToListModalService.isModalOpen$ | async"
    (ionModalDidDismiss)="closeAndDeatachAddToListModal()"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
    id="addToListModal"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="this.addToListModalService.dualPaneRef"
        [rootPageParams]="this.addToListModalService.dualPaneModalData"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>
</ion-content>

<ng-template #SearchResultsHeader>
  <div
    class="search-results-header"
    [ngClass]="
    {
        'tablet': platformService?.platformType === platformService?.platformEnum?.tablet,
        'mobile': platformService?.platformType === platformService?.platformEnum?.mobile,
        'desktop': platformService?.platformType ===  platformService?.platformEnum?.desktop
      }
  "
  >
    <ng-container *ngTemplateOutlet="SearchResultsText;"></ng-container>
    <app-new-search-actions
      *ngIf="newSearchViewModel?.totalCount !== 0 || hasFacetsApplied"
      [facets]="actionBarFacets"
      [usfDeliveredFacetValue]="usfDeliveredFacetValue"
      [deliveryTypeFacet]="deliveryFacet"
      [ourExclusivesFacet]="ourExclusivesFacet"
      (allFiltersPressed)="openFacetFlyout()"
      (facetButtonPressed)="openFacetFlyout($event)"
      [isMobile]="this.platformService.getPlatformType() === platformService.platformEnum.mobile"
      (facetsSelected)="onFacetsSelected($event)"
      [listFacet]="listFacetSharedObject"
      (facetListSelected)="onFacetsListSelected($event)"
    ></app-new-search-actions>
    <div class="search-container">
      <app-new-search-operations
        *ngIf="newSearchViewModel?.totalCount > 0 || hasFacetsApplied"
        [selection]="selection"
        [SelectionType]="SelectionType"
        (compareProducts)="handleSelectionTypeChange($event)"
        [isGuestUser]="isGuestUser"
        [showInventory]="showInventory && !isAddToList"
        [showAddToList]="!isInventory"
        [platform]="platformService.platformType"
        class="search-operations"
      >
      </app-new-search-operations>
      <app-new-search-facet-pills
        class="search-header-facet-pills"
        [facetChipViewModels]="actionBarFacetChipViewModels"
        [showOverflowButton]="true"
        (additionalFacetsClick)="openFacetFlyout()"
        *ngIf="actionBarFacetChipViewModels.length > 0 || listFacetSharedObject?.isValuesSelected"
        (chipMyListSelected)="onFacetsListSelected($event)"
        [listFacet]="listFacetSharedObject"
      ></app-new-search-facet-pills>
    </div>
  </div>
</ng-template>

<ng-template #SearchResultsText>
  <div class="search-results-text">
    <span class="header-text">
      ({{ newSearchViewModel?.totalCount > 999 ? '999+' :
      newSearchViewModel?.totalCount }} {{ 'i18n.common.results' | translate }})
    </span>
  </div>
</ng-template>

<app-facet-flyout-container
  [facetFlyoutTitle]="'i18n.search.allFilters'"
  [platformType]="platformService.getPlatformType()"
  [facets]="flyoutFacets"
  [facetChipViewModels]="facetChipViewModels"
  [isLoading]="coveoSearch?.state?.isLoading && !isLoadingFacetValues"
  (facetsSelected)="onFacetsSelected($event)"
  (clearAll)="clearAllFacets()"
  (facetLoadValues)="facetLoadValues($event)"
  [listFacet]="listFacetSharedObject"
  (facetListSelected)="onFacetsListSelected($event)"
></app-facet-flyout-container>

<ng-template #topSection>
  <div class="top-section-img" *ngIf="!isTouchExperience">
    <div
      class="image-background"
      [style.background-image]="topSectionBackgroundImageStyle"
      [style.background-position]="topSectionBackgroundPosition"
    >
      <ion-grid class="top-section-grid">
        <ion-row class="top-section-row">
          <ion-col class="top-section-col">
            <ion-text
              class="image-text"
              [innerHTML]="topSectionImageTitle | translate"
            >
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  <div class="top-section-expandable-text">
    <div class="expandable-text">
      <h4>{{topSectionTextTitle | translate}}</h4>
      <p
        [style.display]="isTopSectionTextExpanded ? 'block' : 'none'"
        [innerHTML]="topSectionTextContent | translate"
      ></p>
    </div>
    <div class="view-more-container" (click)="expandTopSectionText()">
      <div class="view-more">
        {{ isTopSectionTextExpanded ? ('i18n.common.viewLess' | translate) :
        ('i18n.common.viewMore' | translate) }}
      </div>
      <ion-icon
        name="chevron-down-outline"
        class="chevron"
        *ngIf="!isTopSectionTextExpanded"
      ></ion-icon>
      <ion-icon
        name="chevron-up-outline"
        class="chevron"
        *ngIf="isTopSectionTextExpanded"
      ></ion-icon>
    </div>
  </div>
  <div></div>
</ng-template>
